<template>
  <div class="body" id="chatter"> 
    <message v-for="(message, id) in messages" :message="message" :key="id" :index="id" :allmessages="messages"></message>
  </div>
</template>

<script>
import { db } from '@/firebase'
import Message from '@/components/profile/Message'

export default {
  props: ['chats', 'userid'],
  data () {
    return {
      members: null,
      fbmessages: null
    }
  },
  components: {
    Message
  },
  computed: {
    chatID: function () {
      for (var index in this.chats) {
        let key = this.chats[index]['.key']
        this.$bindAsArray('members', db.ref('chats-members/' + key))
        if (this.members.length === 2) {
          for (var i in this.members) {
            if (this.members[i]['.key'] !== this.$root.user.uid) {
              if (this.members[i]['.key'] === this.userid) {
                console.log
                this.$parent.chatID = key
                return key
              }
            }
          }
        }
      }
    },
    messages: function () {
      if (this.chatID) {
        this.$bindAsArray('fbmessages', db.ref('chats-messages/' + this.chatID))
        return this.fbmessages
      }
    }
  },
  methods: {
    scrollToEnd () {
      var container = document.querySelector('#chatter')
      container.scrollTop = container.scrollHeight
    }
  },
  updated () {
    this.scrollToEnd()
  }
}
</script>



// WEBPACK FOOTER //
// Chat.vue?48e85078